import * as THREE from 'three'
import Experience from '../Experience'

export default class Tv {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources

    //options
    this.resource = this.experience.resources.items.tv
    //methods
    this.setModel()
    this.setTvMaterial()
  }

  setModel() {
    //add model with "scene"
    this.model = this.resource.scene
    this.model.scale.set(1.3, 1.5, 1.5)
    this.model.position.set(8, -2.5, 2)
    this.model.rotation.y = -Math.PI * 0.25
    this.scene.add(this.model)
  }
  setTvMaterial() {
    /**
     * TV
     */
    //tv texture
    this.tvTexture = this.experience.resources.items.tvTexture
    this.tvTexture.flipY = false
    this.tvTexture.encoding = THREE.sRGBEncoding

    //tv material
    this.tvMaterial = new THREE.MeshBasicMaterial({ map: this.tvTexture })
    this.stand = this.model.children.find(child => child.name === 'stand')
    this.tv = this.model.children.find(child => child.name === 'tv')
    this.stand.material = this.tvMaterial
    this.tv.material = this.tvMaterial

    /**
     * Screen
     */
    //screen texture
    this.screenTexture = this.experience.resources.items.screenTexture
    this.screenTexture.flipY = false
    this.screenTexture.encoding = THREE.sRGBEncoding

    //screen material
    this.screenMaterial = new THREE.MeshBasicMaterial({ map: this.screenTexture })
    this.screen = this.model.children.find(child => child.name === 'screen')
    this.screen.material = this.screenMaterial
  }
}
